<template>
    <transition name="fade">
        <div v-if="dataLoading || cartLoading"
             :key="1"
             class="loading-overlay">
            <loader></loader>
        </div>
        <div v-else key="2">
            <div class="featured-outfits-container page-container">
                <featured-outfit 
                    v-for="(outfit, index) in featuredOutfits"
                    :key="outfit.outfit_id"
                    :outfit="outfit"
                    :index="index"
                    @shop-items="showShopItems = true"
                    @swap-product="setSwapProduct"
                />

                <infinite-loading
                    @infinite="getMoreOutfits"
                    ref="infiniteLoading"
                    spinner="waveDots">
                    <div slot="no-more">No more outfits to show!</div>
                    <div slot="no-results" class="no-outfits-message">No Outfits Match These Filters</div>
                </infinite-loading>
            </div>
            <div v-show="shareLoading"
                :key="1"
                class="loading-overlay">
                <loader></loader>
            </div>
            <transition name="fade">
                <swap-item
                    v-if="showSwapProduct" 
                    :product="swapProduct"
                    @close="closeSwapModal"
                />
            </transition>
            <shop-items
                :outfitCurrent="currentOutfit"
                :showShopItems="showShopItems"
                :hideInitialButtons="true"
                @shop-items="showShopItems = false"
                @swap-product="setSwapProduct"
            />
        </div>
    </transition>
</template>

<script>

    import {mapGetters} from 'vuex';
    import Mixins from '../../mixins/mixins.js';
    import Loader from '../common/loader.vue';
    import {_} from 'vue-underscore';
    import InfiniteLoading from 'vue-infinite-loading';
    import { OUTFIT_TYPES } from '../../config.js';
    import FeaturedOutfit from './featured-outfit.vue';
    import ShopItems from '../style-selection/shop-items.vue';
    import SwapItem from '../products/swap-item.vue';

    export default {
        data() {
            return {
                dataLoading: true,
                featuredPageLimit: 10,
                featuredPage: 1,
                swapProduct: null,
                showSwapProduct: false,
                showShopItems: false,
            }
        },
        components: {
            Loader,
            InfiniteLoading,
            FeaturedOutfit,
            ShopItems,
            SwapItem,
        },
        created() {
            let scrollToTop = false;
            this.$store.dispatch('featuredOutfits/fetchFeaturedOutfits')
            .then(response => {
                this.dataLoading = false;
                this.$nextTick(() => {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded();
                });
                scrollToTop = response.scrollToTop;
            })
            .catch(err => {
                this.$helpers.trackEvent("featured_error", {});
                this.dataLoading = false;
            })
            .finally(() => {
                if(!scrollToTop) { 
                    this.$helpers.scrollToLastSavedPosition(this.$router.currentRoute.path);
                }
            });
        },
        computed: {
            ...mapGetters({
                featuredOutfits: 'featuredOutfits/featuredOutfits',
                currentOutfit: 'outfits/currentOutfit',
                cartOutfits: 'cart/getCartOutfits',
                cartLoading: 'cart/getLoadingStatus',
                shareLoading: 'share/getLoadingStatus',
            }),
        },
        methods: {
            getMoreOutfits($state) {
                this.$store.dispatch('featuredOutfits/fetchFeaturedOutfits', this.featuredPage)
                    .then((outfits) => {
                        if(outfits.length === 0){
                            $state.complete();
                        } else {
                            this.featuredPage++;
                            $state.loaded();
                        }
                    }).catch(() => {
                        $state.error();
                    });
            },
            setSwapProduct(product, outfit){
                this.$store.commit('outfits/setCurrentOutfit', {
                    outfit,
                });
                this.showSwapProduct = true;
                this.swapProduct = product;

                this.$helpers.trackEvent("swap_init", {content_id: product.product_id});
            },
            closeSwapModal() {
                this.showSwapProduct = false
                this.$nextTick(() => {
                    if(this.showShopItems) {
                        document.getElementById('main-wrapper').classList.remove('allow-scrolling');
                    }
                });
            }
        },
        mixins: [Mixins],
    }

</script>

<style lang="scss" scoped>
    .no-outfits-message {
        position: absolute;
        top: 50%;
        width: 100%;
        font-size:20px;
    }
</style>